import {useOutlet} from 'reconnect.js';

function useGlobalOutlets() {
  useOutlet('config');
  useOutlet('locale');
  useOutlet('site');
}

export default useGlobalOutlets;
